interface PaginationProps {
    ordering?: string | string[];
    page_size?: number;
    page?: number;
    filters?: Filters;
}

type Pagination = {
    ordering?: string | string[];
    page_size?: number;
    page?: number;
};

interface PaginationReturn<T, K = T extends { id: number | string } ? T['id'] : never> {
    results: T[];
    count: number;
    queryset_ids: K[];
}

type Filters = Record<string, (string | number | 'blank')[]>;

enum ForbiddenTypes {
    DASHBOARD_EVENT_LIST,
    DASHBOARD_EVENT_DETAIL,
    PUBLIC_EVENT_LIST,
    PUBLIC_EVENT_DETAIL,
}

type SmartQueryResult<T, Hook extends (...args: any) => any> = Omit<ReturnType<Hook>, 'data'> & { data?: T };

export { ForbiddenTypes };
export type { Filters, Pagination, PaginationProps, PaginationReturn, SmartQueryResult };
